// angular
// 	.module("HeroPRO")
// 	.controller("AdvancedRegistrationModalController", advancedRegistrationModalController);


import './advancedRegistration.scss';

/* @ngInject */
export default function AdvancedRegistrationModalController(AdvancedRegistrationFactory) {
    const vm = this;
    let pages = [];

    init();

    /*= =======================================
	=            Public Functions            =
	======================================== */
    vm.setVisiblePages = function (activePages) {
        setVisiblePages(activePages);
    };

    vm.isPageVisible = function (page) {
        return pages[page] !== undefined && pages[page].visible === true;
    };
    /* -----  End of Public Functions  ------*/


    /*= =======================================
	=            Private Functions            =
	======================================== */
    function init() {
        pages = AdvancedRegistrationFactory.getPages();
        setVisiblePages();
    }

    function setVisiblePages(pages) {
        if (pages === undefined || pages.length === 0) {
            AdvancedRegistrationFactory.setVisiblePages(['personalInfo']);
        } else {
            AdvancedRegistrationFactory.setVisiblePages(pages);
        }
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/advancedRegistration/advancedRegistrationModalController.js